import {
  getParams,
  updateQueryString,
  objectToQueryString,
} from '@tencent/imutils/dist/esm/util_09_url';
import { tdwReport } from '@tencent/imutils/dist/esm/util_26_tdw_report';
import { request } from '@tencent/imutils/dist/esm/util_21_request';

const gdtReportUrl = 'https://fudao.qq.com/cgi-proxy/gdt/add_user_actions';
const reportData = {
  account_id: '25643',
  user_action_set_id: '1106645824',
  actions: [
    {
      url: '',
      action_type: 'VIEW_CONTENT',
      trace: {
        click_id: '',
      },
      action_param: {},
      outer_action_id: '', // v1.0去重字段 已废弃
      external_action_id: '', // v1.1去重字段
    },
  ],
};

// 广点通上报 key
const GDTClickIdKey = 'qz_gdt';
// 微信上报 key
const WXClickIdKey = 'gdt_vid';
// 抖音上报 key
const DYClickIdKey = 'clickid';

function getGDTClickId() {
  return getParams(GDTClickIdKey);
}

function getWXClickId() {
  return getParams(WXClickIdKey);
}

function getDYClickId() {
  return getParams(DYClickIdKey);
}

function getClickId() {
  return getWXClickId() || getGDTClickId() || getDYClickId();
}

function badjsReportImmediately(msg) {
  if (window.BJ_REPORT) {
    window.BJ_REPORT.report({
      msg,
      level: 2,
    });
  }
}

/**
 * 合并上报参数
 * @param {object} params 上报参数
 * @example {
 *   actionType: '',
 *   outerActionId: '',
 *   actionParam: {},
 * }
 */
function mergeReportData(params = {}) {
  const {
    actionType = 'VIEW_CONTENT',
    outerActionId = '',
    externalActionId = '',
    actionParam,
  } = params;
  const actionsData = reportData.actions[0];
  const clickId = getClickId();

  actionsData.url = window.location.href;
  actionsData.action_type = actionType;
  actionsData.trace.click_id = clickId;
  actionsData.outer_action_id = outerActionId;
  actionsData.external_action_id = externalActionId;

  if (actionParam) {
    actionsData.action_param = actionParam;
  } else {
    delete actionsData.action_param;
  }

  return reportData;
}

/**
 * 广点通 & 微信上报
 * @param {object} params 上报参数
 * @example {
 *   actionType: '',
 *   outerActionId: '',
 *   actionParam: {},
 * }
 */
function gdtReport(params = {}) {
  const clickId = getClickId();
  if (!clickId) {
    return;
  } // 没有 click_id 不作上报
  const dataResult = mergeReportData(params);
  const stringifiedData = JSON.stringify(dataResult);
  request(gdtReportUrl, {
    params: {
      user_actions: stringifiedData,
    },
  }).catch(err => {
    window.imlogger.error('gdtReport faile with:', err);
    window.imlogger.info('gdtReport missing data:', stringifiedData);
  });

  badjsReportImmediately(stringifiedData);
}

/**
 * 抖音上报
 * @param {object} params 上报参数
 */
function dyReport(params = {}) {
  const clickId = getDYClickId();
  if (!clickId) {
    return;
  }

  const data = {
    callback: clickId,
    source: tdwReport.getFromValue(),
    conv_time: parseInt(Date.now() / 1000, 10),
    event_type: params.actionType,
  };
  const qs = objectToQueryString(data);
  const url = `http://ad.toutiao.com/track/activate/?${qs}`;

  const img = new Image();
  img.src = url;

  const stringifiedData = JSON.stringify(data);
  badjsReportImmediately(stringifiedData);
}

/**
 * 广点通 & 微信 & 抖音上报
 * @param {object} params 上报参数
 * @example {
 *   actionType: ''
 * }
 */
function report(params) {
  if (getWXClickId() || getGDTClickId()) {
    return gdtReport(params);
  }

  if (getDYClickId()) {
    return dyReport(params);
  }
}

/**
 * 广点通 & 微信 & 抖音 上报参数透传
 * @param {string} url 上报参数
 */
function addClickIdToURL(url) {
  if (!url) {
    return window.location.href;
  }
  const gdtClickId = getGDTClickId();
  const wxClickId = getWXClickId();
  const dyClickId = getDYClickId();
  if (gdtClickId) {
    url = updateQueryString(url, GDTClickIdKey, gdtClickId);
  }
  if (wxClickId) {
    url = updateQueryString(url, WXClickIdKey, wxClickId);
  }
  if (dyClickId) {
    url = updateQueryString(url, DYClickIdKey, dyClickId);
  }

  return url;
}

const GDT_TYPES_MAP = {
  REGISTER: 'REGISTER',
  VIEW_CONTENT: 'VIEW_CONTENT',
  CONSULT: 'CONSULT',
  CLAIM_OFFER: 'CLAIM_OFFER',
  RESERVATION: 'RESERVATION',
  INITIATE_CHECKOUT: 'INITIATE_CHECKOUT',
  COMPLETE_ORDER: 'COMPLETE_ORDER',
  START_APP: 'START_APP',
  SHARE: 'SHARE',
};

export {
  report,
  gdtReport,
  dyReport,
  addClickIdToURL,
  getClickId,
  getGDTClickId,
  getWXClickId,
  getDYClickId,
  GDTClickIdKey,
  WXClickIdKey,
  DYClickIdKey,
  GDT_TYPES_MAP,
};
